<template>
    <div></div>
</template>

<script>
    import { providerState, sessionState } from "@/state"
    import router from "@/router"

    export default {
        beforeRouteEnter(to) {
            const routeProviderKey = to.params.providerKey
            const providers = providerState.providers

            const index = providers.findIndex(provider => provider.providerKey === routeProviderKey)
            let nextProvider = null

            if (index >= 0) {
                nextProvider = providers[index + 1]
            }

            if (nextProvider && !nextProvider.autoSubmit) {
                nextProvider = null
            }

            if (nextProvider) {
                router.replace({path: `/providers/${nextProvider.providerKey}/prequalifyAgree`})
            } else {
                router.replace({path: `/providers/${sessionState.providerKey}/prequalifySubmit`})
            }

        },
    }
</script>
